<!-- TABLE SECTION STARTS -->

<nz-card>
    <div class="row heading_div m-b-30">
        <div class="col-lg-4 col-sm-4">
            <nz-input-group [nzPrefix]="prefixTemplate">
                <input [(ngModel)]="searchFilter" autocomplete="off" type="text" nz-input placeholder="Search">
            </nz-input-group>
            <ng-template #prefixTemplate>
                <i nz-icon nzType="search" class="opacity-05"></i>
            </ng-template>
        </div>
    </div>

    <nz-table #userDataTable nzBordered [nzData]="userData.data" [nzScroll]="{x: '800px' , y: tableWidth }"
        (nzQueryParams)="onPageChange($event)">
        <thead>
            <tr>
                <th [nzWidth]="column.width" *ngFor="let column of tableHeading">{{ column.title }}</th>
            </tr>
        </thead>

        <tbody>
            <tr id="userListTable" *ngFor="let item of userDataTable.data | filter:searchFilter;  let i=index">
                <td>{{item?.username}}</td>
                <td>{{item?.email}}</td>
                <td>{{item?.phone}}</td>
                <td> {{item?.role}}</td>
                <td class="action-detail">
                    <!-- <button class="update-button" nz-button nzType="primary">Update</button>
                    <button nz-button nzType="">Delete</button> -->
                    <a (click)="openModal(item)" class="m-r-5 edit-button" nz-button nzType="default" nzShape="circle"
                        nz-tooltip nzTooltipTitle="Edit">
                        <i nz-icon nzType="edit" theme="outline"></i>
                    </a>
                </td>
            </tr>
        </tbody>

    </nz-table>

    <ngx-spinner bdColor="#fff" size="medium" color="#00005b" type="line-scale-pulse-out-rapid" [fullScreen]="false">
    </ngx-spinner>
</nz-card>

<!-- TABLE SECTION STARTS -->
<!-- POPUP FORM SECTION STARTS -->

<nz-modal [nzWidth]="modalWidth" [nzStyle]="{ top: '20px' }" [(nzVisible)]="updateModal" nzTitle="Update User Details"
    nzCentered (nzOnCancel)="closeModal()" [nzFooter]="modalFooter" [nzContent]="modalContent">
    <ng-template class="text-center" #modalContent>
        <form [formGroup]="updateForm" (ngSubmit)="updateUser()" nz-form>
            <div class="update_form_div">
                <nz-form-item>
                    <nz-form-label [nzSm]="6" [nzXs]="24" nzRequired nzFor="Company Name">Name</nz-form-label>
                    <nz-form-control [nzSm]="14" [nzXs]="24" nzErrorTip="Please Enter Customer Name!">
                        <nz-input-group>
                            <input autocomplete="off" formControlName="userName" type="text" nz-input id="user_name"
                                placeholder="Customer name" required>
                        </nz-input-group>
                    </nz-form-control>
                </nz-form-item>

                <nz-form-item>
                    <nz-form-label [nzSm]="6" [nzXs]="24" nzRequired nzFor="emailId">Email</nz-form-label>
                    <nz-form-control [nzSm]="14" [nzXs]="24" nzErrorTip="Please Enter Valid Email Address!">
                        <nz-input-group>
                            <input autocomplete="off" formControlName="userEmail" type="email" nz-input id="emailId"
                                placeholder="Enter Email Address">
                        </nz-input-group>
                    </nz-form-control>
                </nz-form-item>

                <nz-form-item>
                    <nz-form-label [nzSm]="6" [nzXs]="24" nzRequired nzFor="mobile">Phone</nz-form-label>
                    <nz-form-control [nzSm]="14" [nzXs]="24" nzErrorTip="Please Enter Phone Number!">
                        <nz-input-group>
                            <input required autocomplete="off" formControlName="userPhoneNumber" nz-input id="mobile"
                                placeholder="Enter Phone Number" type="text"
                                onkeypress="return event.charCode === 0 || /\d/.test(String.fromCharCode(event.charCode));"
                                pattern="[0-9]*" maxlength="10"
                                oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);">
                        </nz-input-group>
                    </nz-form-control>
                </nz-form-item>

                <nz-form-item>
                    <nz-form-label [nzSm]="6" [nzXs]="24" nzRequired nzFor="attributeValue">Role</nz-form-label>
                    <nz-form-control [nzSm]="14" [nzXs]="24" nzErrorTip="Please Select Payment Term!">
                        <nz-input-group>
                            <nz-select autocomplete="off" [(ngModel)]="userRole" [ngModelOptions]="{standalone: true}"
                                (ngModelChange)="roleChange()" class="w-100" nzAllowClear
                                nzPlaceHolder="Select Payment Terms" required>
                                <nz-option nzLabel="Admin" nzValue="Admin"></nz-option>
                                <nz-option nzLabel="Customer" nzValue="Customer"></nz-option>
                                <nz-option nzLabel="Supplier" nzValue="Supplier"></nz-option>
                            </nz-select>
                        </nz-input-group>
                    </nz-form-control>
                </nz-form-item>

                <nz-form-item>
                    <nz-form-label [nzSm]="6" [nzXs]="24" nzRequired nzFor="attributeActive">Active</nz-form-label>
                    <nz-form-control [nzSm]="14" [nzXs]="24">
                        <nz-input-group class="active_status">
                            <nz-switch formControlName="inActive" [nzCheckedChildren]="checkedTemplate"
                                [nzUnCheckedChildren]="unCheckedTemplate">
                            </nz-switch>
                            <ng-template #checkedTemplate><i nz-icon nzType="check"></i></ng-template>
                            <ng-template #unCheckedTemplate><i nz-icon nzType="close"></i></ng-template>
                        </nz-input-group>
                    </nz-form-control>
                </nz-form-item>

                <div *ngIf="userRole != 'Admin'" class="">
                    <nz-form-item>
                        <nz-form-label [nzSm]="6" [nzXs]="24" nzFor="legal_entity">Legal Entity</nz-form-label>
                        <nz-form-control [nzSm]="14" [nzXs]="24">
                            <nz-input-group>
                                <nz-select autocomplete="off" [(ngModel)]="dbData" [ngModelOptions]="{standalone: true}"
                                    (ngModelChange)="getBpList()" class="w-100" nzPlaceHolder="Select Legal Entity">
                                    <nz-option *ngFor="let db of dbList" [nzLabel]="db.dbName" [nzValue]="db.dbCode">
                                    </nz-option>
                                </nz-select>
                            </nz-input-group>
                        </nz-form-control>
                    </nz-form-item>

                    <nz-form-item>
                        <nz-form-label [nzSm]="6" [nzXs]="24" nzFor="list">Company List</nz-form-label>
                        <nz-form-control [nzSm]="14" [nzXs]="24">
                            <nz-input-group>
                                <nz-select autocomplete="off" nzShowSearch [(ngModel)]="bpData"
                                    [ngModelOptions]="{standalone: true}"
                                    (ngModelChange)="structureDBArray(bpData , bpList , 'bp')" class="w-100"
                                    nzPlaceHolder="Select List">
                                    <nz-option *ngFor="let bp of bpList" [nzLabel]="bp.bpName" [nzValue]="bp.bpCode">
                                    </nz-option>
                                </nz-select>
                            </nz-input-group>
                        </nz-form-control>
                    </nz-form-item>

                    <nz-form-item class="text-right ml-5">
                        <nz-form-control [nzSm]="20" [nzXs]="24">
                            <div class="db_access_section">
                                <button type="button" (click)="createList()" nzType="primary" class="add_list-button"
                                    nz-button>Add</button>
                                <div class="db_access_div">
                                    <nz-tag *ngFor="let access of listArray" [nzColor]="'blue'" nzMode="closeable"
                                        (nzOnClose)="clearList(i , $event)">
                                        {{ access?.dbDetails?.dbName + ' - ' + access?.companyDetails?.bpName}}
                                    </nz-tag>
                                </div>
                            </div>
                        </nz-form-control>
                    </nz-form-item>
                </div>
            </div>

            <nz-form-item class="update_submit_section">
                <nz-form-control class="text-center">
                    <button (click)="closeModal()" type="reset" class="mr-5 form-back-button" nz-button
                        nzType="default">Back</button>
                    <a><button nz-button nzType="primary">Update</button></a>
                    </nz-form-control>
            </nz-form-item>
        </form>
        <a (click)="deleteRequest()" class="delete-button">
            <!-- <i nz-icon nzType="delete" theme="outline"></i> -->
            Delete the User
        </a>

    </ng-template>

    <ng-template class="footer-section" #modalFooter> </ng-template>


</nz-modal>

<!-- POPUP FORM SECTION ENSD -->